export default __webpack_public_path__ + "static/media/SDG9.ea364679.png";